<template>
    <Head title="Meu Perfil" />
    <AuthenticatedLayout>
        <Heading title="Meu Perfil" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />
        <article
            class="component-background-desktop component-background-mobile pt-10 pb-14 px-4 xl:px-[16vw] min-h-[80vh]"
        >
            <button
                @click="goBack"
                :class="stateBack"
                class="back-sm hover:text-blue-600 hover:underline text-blue-300"
            >
                Voltar
            </button>
            <div
                class="sm:px-5 xl:max-w-[350px] xl:min-w-[350px] text-blue-500"
            >
                <h2 class="text-3xl font-semibold text-primary text-lef">
                    Push Notifications
                </h2>
                <p class="text-md pb-4">
                    Gerencie os dispositivos que devem receber as noticações e
                    fique sempre ligado!
                </p>

                <form v-if="messaging" @submit.prevent="submit" class="mb-4">
                    <ul class="pt-6">
                        <li class="mb-4">
                            <label class="mb-1 mr-5 flex font-bold"
                                >Apelido do dispositivo</label
                            >
                            <Input
                                placeholder="Ex: Celular, Notebook..."
                                :state="inputState"
                                v-model="form.deviceAlias"
                                type="text"
                                required
                                autofocus
                                class="text-black"
                            />
                        </li>

                        <li>
                            <Button @click.prevent="submit"
                                >Registar dispositivo atual</Button
                            >
                        </li>
                    </ul>
                </form>

                <div v-if="$page.props.flash.error">
                    {{ $page.props.flash.error }}
                </div>

                <div v-if="$page.props.flash.success">
                    {{ $page.props.flash.success }}
                </div>
            </div>
            <div
                class="sm:px-5 xl:max-w-[700px] xl:min-w-[350px] text-blue-500"
            >
                <h2 class="text-3xl font-semibold text-primary text-lef">
                    Lista de Dispositivos conectados
                </h2>
                <div class="p-[1rem] grid grid-cols-3 text-center w-full">
                    <p class="font-black border-r pb-5">Apelido do Dispositivo</p>
                    <p class="font-black border-r pb-5">Data de Criação</p>
                    <p class="font-black pb-5">Excluir</p>
                </div>
                <div class="p-[1rem] bg-white table rounded w-full">
                    <div
                        v-for="(data, key) in codes"
                        :key="key"
                        class="grid grid-cols-3 grid-cols-list-clientes items-center"
                    >
                        <div class="border-r p-4 border-gray-300">
                            <p class="font-black text-black">
                                {{ data.deviceAlias }}
                            </p>
                        </div>
                        <div class="border-r p-4 border-gray-300">
                            <p class="font-black text-black">
                                {{ formatUpdatedDate(data.createdAt) }}
                            </p>
                        </div>

                        <div
                            class="border-r grid items-center justify-center p-4 border-gray-300"
                        >
                            <a
                                :href="
                                    route(
                                        'dashboard.delete-push-notification',
                                        data.id
                                    )
                                "
                                class="table bg-gray-100 p-3 rounded text-black"
                            >
                                <Icon name="Excluir" />
                            </a>
                        </div>
                    </div>
                </div>

                <!-- <div v-if="$page.props.flash.success">
                    {{ $page.props.flash.success }}
                </div> -->
            </div>
        </article>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Input from "@/Components/UI/Form/Input.vue";
import { Head } from "@inertiajs/inertia-vue3";
import Heading from "@/Components/UI/Texts/Heading.vue";
import Back from "@/Components/UI/Back.vue";
import Button from "@/Components/Button.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import { formatUpdatedDate } from "@/Helpers/masks";
import { messaging } from "@/firebase";

export default {
    components: {
        AuthenticatedLayout,
        Head,
        Heading,
        Back,
        Input,
        Button,
        Icon,
    },
    props: {
        codes: Array,
    },
    data() {
        return {
            showSuccessModal: false,
            showModal: true,
            confirmPassword: "",
            form: this.$inertia.form({
                deviceAlias: "",
            }),
            messaging,
        };
    },
    methods: {
        submit() {
            if (this.form.deviceAlias && this.form.deviceAlias.trim() !== "") {
                messaging &&
                    messaging
                        .requestPermission()
                        .then(() => messaging.getToken())
                        .then((token) => {
                            this.$inertia
                                .post("/my-profile/push-notification", {
                                    code: token,
                                    alias: this.form.deviceAlias,
                                })
                                .catch(function (error) {
                                    console.log("Erro:", error);
                                });
                        });
            }
        },
        goBack() {
            return window.history.go(-1);
        },
        formatUpdatedDate,
    },
};
</script>
